import { render, staticRenderFns } from "./FlagHistoryDetails.vue?vue&type=template&id=31950553&"
import script from "./FlagHistoryDetails.vue?vue&type=script&lang=js&"
export * from "./FlagHistoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports